define(["app/modules/utilities"], function(utilities) {
  var SCROLL_THRESHOLD = 400;
  var HIDDEN_CLASS = "hidden";

  var InfiniteScroll = function(params) {
    this.$window = $(window);
    this.$el = params.$el;
    this.$loadMoreSpinner = $(".js-filtering-list-spinner");
    this.elTopOffset = this.$el.offset().top;
    this.elHeight = this.$el.height();
    this.windowHeight = this.$window.height();
    this.onLoadSuccess = params.onLoadSuccess;

    this.handleScroll = this.handleScroll.bind(this);
    this.setWindowHeight = this.setWindowHeight.bind(this);

    this.bindScroll();
  };

  InfiniteScroll.prototype.bindScroll = function() {
    this.$window.on("resize", this.setWindowHeight);
    window.addEventListener("mousewheel", this.performChrome);
    this.$window.scroll(utilities.throttle(this.handleScroll, 400));
  };

  InfiniteScroll.prototype.setWindowHeight = function() {
    this.windowHeight = this.$window.height();
  };

  InfiniteScroll.prototype.handleScroll = function() {
    if (this.isPending) return;

    var bottomBreakpoint = this.elTopOffset + this.elHeight;
    if (
      bottomBreakpoint - this.windowHeight - SCROLL_THRESHOLD <=
      window.pageYOffset
    ) {
      var $link = $(".js-list-hidden-link");

      if (!$link.length) return;

      var self = this;
      this.isPending = true;
      this.$loadMoreSpinner.removeClass(HIDDEN_CLASS);

      $.ajax({
        type: "GET",
        url: $link.attr("href"),
        success: function(results) {
          self.onLoadSuccess(results);
          self.isPending = false;
          self.$loadMoreSpinner.addClass(HIDDEN_CLASS);
          self.elHeight = self.$el.height();
        }
      });
    }
  };

  InfiniteScroll.prototype.performChrome = function(e) {
    if (e.deltaY === 1) {
      e.preventDefault();
    }
  };

  return InfiniteScroll;
});
